import { Empty } from 'antd';

export function EmptyState() {
  return (
    <div className="h-full flex items-center justify-center">
      <Empty
        description="Please select a pairing history or menu from the left, or create a new pairing"
        className="mt-[-100px]"
      />
    </div>
  );
}
